import React from 'react';
import { Container } from '../../../../components/Container';
import { SectionHeading } from '../../../../components/SectionHeading';
import { Typography } from '../../../../components/Typography';
import { Box } from '../../../../wag-react/next-components/box';
import { MeetTheVetsCarousel } from './components/MeetTheVetsCarousel';
export const MeetTheVetsCarouselSection = () => <Container py={['48px', null, '96px']} px={['unset', '24px']} data-sentry-element="Container" data-sentry-component="MeetTheVetsCarouselSection" data-sentry-source-file="index.tsx">
    <Box maxWidth={['100%', null, '50%']} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <SectionHeading color="#727272" textAlign="left" px={['16px', '24px']} data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
        Ask a Certified Veterinarian Professional
      </SectionHeading>
      <Typography color="#727272" maxWidth={['916px']} mb={0} mt="16px" mx="auto" px={['16px', '24px']} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
        Skip expensive and stressful in-office visits. Get fast, affordable answers.
      </Typography>
      <MeetTheVetsCarousel data-sentry-element="MeetTheVetsCarousel" data-sentry-source-file="index.tsx" />
    </Box>
  </Container>;